import React from "react";

const SkeletonAspirasiDetail = () => {
  return (
    <div className="rounded-xl shadow-md border p-4 flex flex-col items-center bg-white animate-pulse">
      {/* Foto */}
      <div className="w-full h-56 bg-gray-300 rounded-lg mb-4" />

      {/* Tombol */}
      <div className="w-full h-10 bg-gray-300 rounded-lg" />
    </div>
  );
};

const SkeletonGridDetailAspirasi = () => {
  return (
    <div className="w-full gap-6">
      {[...Array(1)].map((_, i) => (
        <SkeletonAspirasiDetail key={i} />
      ))}
    </div>
  );
};

export default SkeletonGridDetailAspirasi;
